declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_crumb2_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_crumb2_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_crumb2_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_crumb2_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_crumb2_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_crumb2_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_crumb2_7 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_crumb2_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb2_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_gamengine_demo_crumb2_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_gamengine_demo_crumb2_11 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['restart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_page__title_bog_gamengine_demo_crumb2_12 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['end_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_demo_crumb2_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_crumb2_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb2_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_crumb2_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gamengine_clock__paused_bog_gamengine_demo_crumb2_17 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['paused'] >
		,
		ReturnType< $bog_gamengine_clock['paused'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_crumb2_18 = $mol_type_enforce<
		({ 
			'left': readonly(any)[],
			'right': readonly(any)[],
			'up': readonly(any)[],
			'down': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_crumb2_19 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_demo_crumb2_20 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__pos_bog_gamengine_demo_crumb2_21 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['cam_pos'] >
		,
		ReturnType< $bog_gamengine_cam_flat['pos'] >
	>
	type $bog_gamengine_demo_crumb2_level__clock_bog_gamengine_demo_crumb2_22 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Clock'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_level['clock'] >
	>
	type $bog_gamengine_demo_crumb2_level__input_bog_gamengine_demo_crumb2_23 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Input'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_level['input'] >
	>
	type $bog_gamengine_demo_crumb2_level__cam_bog_gamengine_demo_crumb2_24 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['Cam'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_level['cam'] >
	>
	type $bog_gamengine_demo_crumb2_level__auto_nodes_bog_gamengine_demo_crumb2_25 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['nodes'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_level['auto_nodes'] >
	>
	type $bog_gamengine_demo_crumb2_rule__hero_bog_gamengine_demo_crumb2_26 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['hero'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_rule['hero'] >
	>
	type $bog_gamengine_demo_crumb2_rule__crumbs_bog_gamengine_demo_crumb2_27 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2['crumbs'] >
		,
		ReturnType< $bog_gamengine_demo_crumb2_rule['crumbs'] >
	>
	type $bog_gamengine_demo_crumb2_rule__limit_bog_gamengine_demo_crumb2_28 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_crumb2_rule['limit'] >
	>
	export class $bog_gamengine_demo_crumb2 extends $mol_page {
		left_str( ): string
		Left_label( ): $mol_labeler
		time_str( ): string
		Time_label( ): $mol_labeler
		paused( ): boolean
		Pause_switch( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_crumb2['Draw'] >['stat'] >
		Draw( ): $bog_gamengine_draw
		end_title( ): string
		end_hint( ): string
		End_hint( ): $mol_view
		restart( next?: any ): any
		Again( ): $mol_button_major
		End( ): $mol_page
		field( ): readonly(any)[]
		hero_str( ): string
		Hero_stat( ): $mol_view
		Stat( ): $mol_view
		cam_pos( ): Float32Array
		nodes( ): readonly(any)[]
		hero( ): any
		crumbs( ): readonly(any)[]
		title( ): string
		key_map( ): Record<string, any>
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_gamengine_demo_crumb2['field'] >
		foot( ): readonly(any)[]
		Clock( ): $bog_gamengine_clock
		Key( ): $bog_gamengine_key
		Input( ): $bog_gamengine_input
		Cam( ): $bog_gamengine_cam_flat
		Scene( ): $bog_gamengine_demo_crumb2_level
		Rule( ): $bog_gamengine_demo_crumb2_rule
	}
	
}

//# sourceMappingURL=crumb2.view.tree.d.ts.map